/**
 * @flow
 * @author Box
 */

export interface AiExtractResponse {}
